import axios from 'axios';

export default {
    namespaced: true,

    state: {
        token: null,
        user: null,
    },

    getters: {
        authenticated(state) {
            return state.token && state.user;
        },
        user(state) {
            return state.user;
        },
    },

    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_USER(state, data) {
            state.user = data;
        },
    },

    actions: {
        async logIn({dispatch}, credentials) {
            let response = await axios.post('auth/login', credentials);

            return dispatch('attempt', response.data.data.token);
        },

        confirmEmail({dispatch}, data) {
            return axios.post('auth/confirm-email', data);
        },

        sendVerificationLink({dispatch}, email) {
            return axios.post('auth/send-verification-link', {email: email});
        },

        forgotPassword({dispatch}, credentials) {
            return axios.post('auth/forgot-password', credentials);
        },

        register({dispatch}, credentials) {
            return axios.post('auth/register', credentials);
        },

        resetPassword({dispatch}, credentials) {
            return axios.post('auth/reset-password', credentials);
        },

        checkResetToken({dispatch}, token) {
            return axios.post('auth/check-reset-token', {token: token});
        },

        async attempt({commit, state, dispatch}, token) {
            if (token) {
                commit('SET_TOKEN', token);
            }

            if (!state.token) {
                return;
            }

            return new Promise(async (resolve, reject) => {
                try {
                    let response = await axios.get('auth/me');

                    commit('SET_USER', response.data.data);

                    resolve(response)
                } catch (e) {
                    commit('SET_TOKEN', null);
                    commit('SET_USER', null);

                    reject(e)
                }
            })
        },

        logout({commit}) {
            return axios.post('auth/logout').then(() => {
                commit('SET_TOKEN', null);
                commit('SET_USER', null);
            });
        }
    }
};
